var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');
import IconLoadService from 'services/icon-load-service';
const PageService = require('services/page-service');
const match = require('minta').match;
import { KeybindingService, keys } from 'services/keybinding-service';
var ef = require('ef/ef');

const { Enter, Space, ArrowUp, ArrowDown } = keys;

/***
 * @View
 * @name accordion
 * @type block
 * @description An accordion with collapsable bellows
 * @content
 *  @prop [required] type={string} title="completion requirement" default="none"
 *    "none"
 *    "all"
 *  @prop [direction] type={string} title="direction" default="none"
 *    "horizontal"
 *    "vertical"
 *   @prop [events] type={string} title="Style" default="click"
 *    "hover"
 *    "click"
 *  @prop [style] type={string} title="Style" default="click"
 *    "hover"
 *    "click"
 *  @prop stepper type={boolean} \
 *    title="stepper? (Use icon isntead of generic symbol for stepper)"
 *  @prop icon_visited type={boolean} \
 *    title="visited? (Use icon isntead of generic symbol for visited)"
 *  @prop @advanced allowMultiple type={boolean} title="Allow multiple bellows to be opened at a time?"
 *  @prop @advanced scrollPane type={string} title="scrollPane" \
 *    description="JQuery Selector for selecting Scroll Pane containing the
 *                 accordion block in order to activate 'scroll to active bellow'
 *                 behavior for accordion (defaults is 'html, body')" \
 *    default="html, body"
 *  @contains @array_of 'bellows' with:
 *    @title "bellows"
 *    @minimum 2
 *    @prop @advanced sr_header_text type={string} title="Screen Reader Text" description="Screen Reader Text"
 *    @prop icon_header_prefix type={string} title="Icon header prefix" description="Prefix for header icon"
 *    @prop @required @advanced class type={string} description="Class name(s)"
 *    @prop header type={string} title="header" description="Expandable "
 *    @prop icon_header type={string} title="font awesome icon" @allow iconPicker
 *    @prop custom type={boolean} title="custom" desription="Give description a disc mark?"
 *    @prop description_class type={boolean} title="Description class" \
 *      description="CSS class for description"
 *    @prop description type={string} title="description" \
 *      header="Expandable header text for this bellow"
 *
 *    @contains @advanced 'header_region' with:
 *      @includes blocks: {{blocks}}
 *    @end
 *
 *    @contains @advanced 'body_region' with:
 *      @includes blocks: {{blocks}}
 *    @end
 *  @end
 */

var AccordionView = BlockView.extend({
  className: 'accordion-container',
  initialize: function () {
    // set defaults and events
    this.model.set(
      'direction',
      match(this.model.get('direction'))(
        'horizontal',
        _ => 'horizontal',
        'vertical',
        _ => 'vertical',
        _otherwise => 'vertical'
      )
    );
    this.model.set(
      'events',
      match(this.model.get('style'))(
        'hover',
        _ => 'mouseover touchstart',
        'click',
        _ => 'click touchend',
        _otherwise => 'click'
      )
    );
    //get the icon index

    this.model.get('bellows').forEach((element, index) => {
      if (this.model.has('bellows')) {
        if (ef.forge_mode) {
          element.forge_mode = true;
        }
        const index_id = index === 0 ? this.model.cid : `${this.model.cid}-${index}`;
        element.displayHeader = LocaleService.t(element.header);

        const iconParams = this.filterParameters(element);

        if (this.model.get('stepper')) {
          IconLoadService.applyIcon('fal fa-check', index_id);
        }

        if (iconParams) {
          if (iconParams.prefix) {
            IconLoadService.applyIcon(iconParams.name, index_id, element.icon_header_classes, iconParams.prefix);
          } else {
            IconLoadService.applyIcon(iconParams.name, index_id, element.icon_header_classes);
          }
        }
      }
    });

    this.subscribeEvent('course-nav:clicked', function () {
      // if activity-links exist within an accordion lets fix the tabindex
      $('.activity-link').attr('tabindex', -1);
    });

    BlockView.prototype.initialize.apply(this, arguments);
  },
  _initialize() {},

  filterParameters(accordionModel) {
    if (accordionModel.hasOwnProperty('icon_header_prefix')) {
      return {
        prefix: accordionModel.icon_header_prefix,
        name: accordionModel.icon_header,
      };
    } else if (accordionModel.hasOwnProperty('icon_header')) {
      return {
        name: accordionModel.icon_header,
      };
    }
  },

  load: function () {
    this._initialize();
    const completed = new Set();
    const allowMultiple = this.model.get('allowMultiple') ? this.model.get('allowMultiple') : false;

    this.delegate(`${this.model.get('events')} keydown`, '.bellow-container > .bellow-header', e => {
      const $element = $(e.currentTarget).closest('.bellow-container');

      if (!$element.hasClass('active')) {
        $element.find('.bellow').hide();
      }

      if (e.type === 'keydown') {
        KeybindingService.with(e).bind(
          [Enter, Space],
          () => {
            this._toggle(e, $element, completed, allowMultiple);
          },
          [ArrowUp],
          () => {
            const thisTrigger = $element.prev().find('.accordion-trigger');
            thisTrigger.focus();
            e.preventDefault();
          },
          [ArrowDown],
          () => {
            const thisTrigger = $element.next().find('.accordion-trigger');
            thisTrigger.focus();
            e.preventDefault();
          }
        );
      } else {
        this._toggle(e, $element, completed, allowMultiple);
      }
    });

    this.model.get('bellows').forEach((bellow, index) => {
      if (bellow.header_region != undefined) {
        this.renderNestedBlocks(`${this.model.get('cid')}-header_region-${index}-blocks`, bellow.header_region.blocks);
      }
      if (bellow.body_region != undefined) {
        this.renderNestedBlocks(`${this.model.get('cid')}-body_region-${index}-blocks`, bellow.body_region.blocks);
      }
    });
    //orientation
    window.addEventListener('orientationchange', () => {
      const bellows = document.querySelectorAll('.bellow');
      bellows.forEach(bellow => {
        const parentElement = bellow.closest('.bellow-container');
        if (parentElement.classList.contains('active')) {
          const newHeight = window.innerHeight;
          bellow.style.maxHeight = `${newHeight}px`;
        } else {
          bellow.style.maxHeight = '0';
        }
      });
    });
  },

  _changeAriaState: function ($element, enable) {
    $('article', $element).attr({ 'aria-hidden': !enable });
    $element.find('.accordion-trigger').attr('aria-expanded', enable);
  },

  _toggle(e, $element, completed, allowMultiple) {
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopImmediatePropagation();
    if (allowMultiple) {
      let accordionProperties = {
        AriaState: false,
        statusAccordion: 'closed',
      };

      $element.hasClass('visited') ? true : $element.addClass('visited');
      $element.toggleClass('active');
      if ($element.hasClass('active')) {
        accordionProperties.AriaState = true;
        accordionProperties.statusAccordion = 'open';
      } else {
        accordionProperties.AriaState = false;
        accordionProperties.statusAccordion = 'closed';
      }
      this._changeAriaState($element, accordionProperties.AriaState);
      AhoyService.track('accordion', {
        action: 'toggle',
        state: accordionProperties.statusAccordion,
        class: $element.attr('class'),
      });
    } else {
      const $previousActiveItem = this.$el.parent().find('.bellow-container.active');
      $previousActiveItem.removeClass('active');
      $previousActiveItem.find('.bellow').css('max-height', 0);
      this._hideBellow($previousActiveItem);
      this._changeAriaState($previousActiveItem, false);

      if ($element.index() !== $previousActiveItem.index()) {
        $element.addClass('active visited');
        this._changeAriaState($element, true);
        AhoyService.track('accordion', {
          action: 'toggle',
          state: 'open',
          class: $element.attr('class'),
        });
      }
    }
    // Enable smooth animation based on content height
    const bellow = $element.find('.bellow');

    if (bellow) {
      let newHeight = 0;
      if ($element.hasClass('active')) {
        bellow.find('.activity-link').attr('tabindex', 0);
        bellow.show();
        newHeight = bellow.prop('scrollHeight');
      } else {
        this._hideBellow($element);
      }
      bellow.css('max-height', newHeight);
    }

    if (this.model.get('scrollPane')) {
      PageService.setScrollToElement($element, $(this.model.get('scrollPane')));
    }

    //aria-label
    const $accordionTrigger = $('.accordion-trigger', $element);
    const title = this.model.get('bellows')[$element.index()].sr_header_text
      ? LocaleService.t(this.model.get('bellows')[$element.index()].sr_header_text)
      : String($accordionTrigger.text()).trim();
    $accordionTrigger.attr(
      'aria-label',
      `${title} ${LocaleService.t(
        $element.hasClass('active') ? 'accordion.bellowVisitedExpanded' : 'accordion.bellowVisitedCollapsed'
      )}`
    );

    // completion
    completed.add($element.index());
    if (!this.model.get('completed')) {
      if (this._checkComplete($element, completed)) {
        this.model.set('completed', true);
        AhoyService.track('accordion', { action: 'completed' });
        this.readyToGo();
      }
    }
  },

  _hideBellow($element) {
    $element
      .find('.bellow')
      .delay(500)
      .queue(function (next) {
        if (!$element.hasClass('active')) {
          $(this).hide();
        }
        next();
      });
    $element.find('.activity-link').attr('tabindex', -1);
  },

  _checkComplete($element, completed) {
    return match(this.model.get('required'))(
      Number,
      index => {
        return index - 1 === $element.index();
      },
      'none',
      _ => true,
      _otherwise => {
        return completed.size === this.model.get('bellows').length;
      }
    );
  },

  play: function () {
    if (this.model.get('required') === 'none') {
      this.readyToGo();
    }
  },
});

module.exports = AccordionView;
